import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Module, TextPosition} from "../../model/ModuleModel";
import {TableConfiguration} from "./table-module.model";
import {ScreenType} from "../../model/ScreenType";
import { AbstractComponent } from '../abstract.component';

@Component({
  selector: 'table-module',
  template: `
    <div class="{{textPosition}}">
      <main-title [data]="{title: module.title, sub_title: module.subtitle, pre_title: module.pretitle}"
                  titleColor="#444" preTitleColor="#888" subtitleColor="#888" class="-eva-3-mb-sm"
                  [moduleId]="module.id" [uniqueId]="module.unique_id"></main-title>
      <div class="eva-3-card">
        <table class="google_table">
          <tbody>
          <ng-container *ngFor="let row of module.data.items">
            <tr class="row" *ngIf="isNotEmpty(row)">
              <td class="column" *ngFor="let cell of row" [innerHTML]="cell | safeHtml"></td>
            </tr>
          </ng-container>
          </tbody>
        </table>

      </div>
    </div>
  `,
  styleUrls: ['./table-module.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TableModuleComponent extends AbstractComponent implements OnInit {
  public static MODULE_ID: string = "TableModule";
  @Input() override module: Module<TableConfiguration>
  @Input() override screenType: ScreenType;

  textPosition: TextPosition;
  
  ngOnInit(): void {
    this.textPosition = (!this.module.text_position || this.screenType !== 'DESKTOP') ? TextPosition.TOP : this.module.text_position;
  }

  isNotEmpty = (row: string[]) : boolean => {
    return row?.every(cell => cell?.trim());
  }

  getModuleId(): string {
    return TableModuleComponent.MODULE_ID;
  }
}